<template>
  <v-row
    no-gutters
    justify="start"
    :class="{ 'details-content': product.images.length }"
  >
    <v-col cols="12">
      <span
        v-if="product.oldPrice"
        class="modal-price old-price pr-3"
        v-text="$appFormatters.formatMoney(product.oldPrice)"
      />
      <span class="modal-price" v-text="$appFormatters.formatMoney(price)" />
    </v-col>
    <!-- Pickup date information - Alert at top -->
    <v-col
      v-if="product.requiredPickupDateFrom || shouldShowAvailableFrom"
      cols="12"
      class="mt-3 mb-3"
    >
      <v-alert type="info" dense outlined>
        <div class="pickup-date-info">
          <strong class="pickup-date-title">{{
            $t("discovery.product_info")
          }}</strong>
        </div>
        <div v-if="product.requiredPickupDateFrom" class="mt-2">
          <p class="pickup-date-text mb-1">
            <strong>{{ $t("discovery.available_between") }}:</strong>
            {{ formatDate(product.requiredPickupDateFrom) }} -
            {{ formatDate(product.requiredPickupDateTo) }}
          </p>
        </div>
        <div v-if="shouldShowAvailableFrom" class="mt-1">
          <p class="pickup-date-text mb-0">
            <strong>{{ $t("discovery.available_for_order_from") }}:</strong>
            {{ formatDate(product.availableForOrderFrom) }}
          </p>
        </div>
      </v-alert>
    </v-col>
    <v-col cols="12">
      <span class="modal-description" v-text="product.description" />
    </v-col>
    <v-col v-if="product.productVariation.length > 0" cols="12">
      <v-divider class="mt-4" />
    </v-col>
    <VariationsComponent
      v-model="localVariation"
      :datas="product.productVariation"
      @input="updateVariation"
    />
    <AddonsComponent
      v-model="localAddons"
      :datas="product.groupAddons"
      @input="updateAddons"
    />
    <!--    <div v-if="product.images.length > 0" style="min-height: 150px" />-->
  </v-row>
</template>
<script>
import VariationsComponent from "@/views/front/discovery/components/VariationsComponent.vue";
import AddonsComponent from "@/views/front/discovery/components/AddonsComponent.vue";

export default {
  name: "ProductModalDetail",
  components: {
    VariationsComponent,
    AddonsComponent,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    selectVariation: {
      type: Object,
      default: null,
    },
    selectAddons: {
      type: Array,
      default: () => [],
    },
    form: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: true,
      localVariation: this.selectVariation,
      localAddons: this.selectAddons,
    };
  },
  computed: {
    totalPriceAddons: {
      get() {
        let total = 0;
        if (this.localAddons.length > 0) {
          total = this.localAddons.reduce(function (total, currentValue) {
            return total + parseFloat(currentValue.subtotal);
          }, 0);
          return total.toFixed(2);
        } else {
          return 0;
        }
      },
      set(val) {
        return val;
      },
    },
    totalPrice: {
      get() {
        let subTotal =
          parseFloat(this.price) + parseFloat(this.totalPriceAddons);
        let total = this.form.productQty * subTotal;
        return total.toFixed(2);
      },
      set(val) {
        return val;
      },
    },
    price: {
      get() {
        return this.localVariation
          ? this.localVariation.price
          : parseFloat(this.product.price).toFixed(2);
      },
      set(val) {
        return val;
      },
    },
    shouldShowAvailableFrom: function () {
      if (
        !this.product.availableForOrderFrom ||
        !this.product.requiredPickupDateFrom
      ) {
        return false;
      }

      const availableFrom = new Date(this.product.availableForOrderFrom);
      const pickupFrom = new Date(this.product.requiredPickupDateFrom);
      const pickupTo = new Date(this.product.requiredPickupDateTo);

      availableFrom.setHours(0, 0, 0, 0);
      pickupFrom.setHours(0, 0, 0, 0);
      pickupTo.setHours(0, 0, 0, 0);

      // Only show if availableForOrderFrom is between requiredPickupDateFrom and requiredPickupDateTo
      return availableFrom >= pickupFrom && availableFrom <= pickupTo;
    },
  },
  watch: {
    selectVariation(newVal) {
      this.localVariation = newVal;
    },
    selectAddons(newVal) {
      this.localAddons = newVal;
    },
  },
  methods: {
    visibilityChanged(isVisible) {
      this.isVisible = isVisible;
      this.$emit("visibility-changed", isVisible);
    },
    updateVariation(value) {
      this.$emit("update:select-variation", value);
    },
    updateAddons(value) {
      this.$emit("update:select-addons", value);
    },
    increment() {
      this.$emit("increment");
    },
    decrement() {
      this.$emit("decrement");
    },
    addToCart() {
      this.$emit("add-to-cart");
    },
    formatDate: function (dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("da-DK", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
  },
};
</script>
<style scoped lang="scss">
.pickup-date-info {
  margin-bottom: 4px;
}

.pickup-date-title {
  font-weight: 600;
  font-size: 0.95rem;
}

.pickup-date-text {
  font-size: 0.9rem;
  margin: 0;
  line-height: 1.5;
}
</style>
